import { Box } from '@mui/material';
import { ReactComponent as LockIcon } from 'assets/lock-password.svg';
import EntryLayoutScreen from 'components/shared/EntryLayout/EntryLayout';
import RoutePaths from 'routes/RoutePaths';
import zeplinColor from 'theme/Color';
import SetNewPasswordForm from './SetNewPasswordForm';

const CompleteAccount = () => {
  return (
    <EntryLayoutScreen
      header={'Complete Your Account Setup'}
      subheader={
        'Your email is confirmed. Create a strong password below to secure and activate your account.'
      }
      icon={
        <Box
          sx={{
            margin: '40px auto 0',
            backgroundColor: zeplinColor.Neutral3,
            borderRadius: '70px',
            width: '80px',
            height: '80px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <LockIcon />
        </Box>
      }
      input={<SetNewPasswordForm />}
      path={RoutePaths.CompleteAccount}
      footerText={''}
      footerButtonText={''}
      clickAction={() => alert('click')}
    />
  );
};

export default CompleteAccount;
